import _ from "lodash";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(isBetween);

export const showEvents = events => {
  const currentEvents = _.filter(events, event => {
    const startTime = _.get(event, "event_start_time");
    const endTime = _.get(event, "event_end_time");
    return dayjs().isBetween(startTime, endTime, null, "[]");
  });
  const orderCurrentEvents = _.sortBy(currentEvents, [
    "event_start_time",
    "event_end_time",
    "updated_at"
  ]);

  const upcomingEvents = _.filter(events, event => {
    const startDate = _.get(event, "event_start_time");
    return dayjs().isBefore(startDate);
  });
  const orderUpcomingEvents = _.sortBy(upcomingEvents, [
    "event_start_time",
    "event_end_time",
    "updated_at"
  ]);

  const olderEvents = _.filter(events, event => {
    const endDate = _.get(event, "event_end_time");
    return dayjs().isAfter(endDate);
  });
  const orderOlderEvents = _.sortBy(olderEvents, [
    "event_start_time",
    "event_end_time",
    "updated_at"
  ]);
  const orderEvents = [
    ...orderCurrentEvents,
    ...orderUpcomingEvents,
    ...orderOlderEvents
  ];
  return orderEvents;
};



// WEBPACK FOOTER //
// ./src/selectors/event.js